<template>
    <div class="count-up">
        <div class="count-up__counter" :class="[ loading ? 'inactive' : '', align == 'left' ? 'countup-left' : '' ]" :style="styleComputed">
            <ICountUp
                :delay="100"
                :endVal="endVal"
                :options="options"
            />
        </div>
        <div class="mt-xl-3 mt-md-3" v-html="text"></div>
    </div>
</template>
<script>
import ICountUp from 'vue-countup-v2';

export default {
    props: ['endVal', 'text', 'loading', 'countOptions', 'align', 'fontSize'],
    components: {
        ICountUp
    },
    data() {
        return {
            options: this.countOptions != null ? this.countOptions : {
                useEasing: true,
                useGrouping: true,
                separator: ',',
                decimal: '.',
                prefix: '',
                suffix: ''
            }
        }
    },
    computed: {
        styleComputed() {
            var fontSize = "";
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': fontSize = this.fontSize != null ? this.fontSize + 'rem' :'3rem'; break;
                case 'sm': fontSize =  this.fontSize != null ? this.fontSize + 'rem' :'4rem'; break;
                case 'md': fontSize =  this.fontSize != null ? this.fontSize + 'rem' :'4rem'; break;
                case 'lg': fontSize =  this.fontSize != null ? this.fontSize + 'rem' :'4rem'; break;
                case 'xl': fontSize =  this.fontSize != null ? this.fontSize + 'rem' :'4rem'; break;
                default: fontSize =  this.fontSize != null ? this.fontSize + 'rem' :'4rem'; break;
            }

            var lineHeight = "";
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': lineHeight = '50px'; break;
                case 'sm': lineHeight = '50px'; break;
                case 'md': lineHeight = '50px'; break;
                case 'lg': lineHeight = '50px'; break;
                case 'xl': lineHeight = '50px'; break;
                default: lineHeight = '50px'; break;
            }

            return {
                "font-size" : fontSize,
                "line-height" : lineHeight
            };
        },
    }
}
</script>
<style scoped>
    .count-up {
        text-align: center;
    }
    .countup-left {
        text-align: left;
    }
    .count-up__counter {
        font-weight: 300;
    }
    .inactive {
        color: #b9b9b9;
    }
</style>